import React, {useState} from 'react'



export default function TextForm(props) {
  const handleUpClick = ()=>{
    let newText = text.toUpperCase();
    setText(newText);
  }
  const handleDownClick = ()=>{
    let newText = text.toLowerCase();
    setText(newText);
  }

  const handleOnChange = (event)=>{
    setText(event.target.value);
  }

  const [text, setText] = useState('');
  return (
    <>
  <h1>{props.title}</h1>
  <div className="mb-3">
    <label htmlFor="FormControl" className="form-label">Enter Your Text Below</label>
    <textarea className="form-control" value={text} onChange={handleOnChange} id="FormControl" rows="6" ></textarea>
  
  </div>
  <button type="button" onClick={handleUpClick} className="btn btn-primary">Convert To Uppercase</button>
  <button type="button" onClick={handleDownClick} className="btn btn-primary mx-3">Convert To Lowercase</button>
  <div className="container">
    <h1>Your Text Summary</h1>
    <p>{text.split(" ").length} words and {text.length} characters</p>
    <p>{(0.008 * text.split(" ").length).toFixed(2)} Minutes read</p>
    <h2>Preview</h2>
    <p>{text}</p>
  </div>
</>
    
  )
}
